import React, { useState } from 'react';
import VoucherRail from '@/components/vouchers/VoucherRail';
import { useNavigate } from 'react-router-dom';
import useMetallicOrder from '@/components/proepoxy/hooks/useMetallicOrder';
import MetallicStep1 from '@/components/proepoxy/metallic-steps/MetallicStep1';
import MetallicStep2 from '@/components/proepoxy/metallic-steps/MetallicStep2';
import MetallicStep3 from '@/components/proepoxy/metallic-steps/MetallicStep3';
import MetallicStep4 from '@/components/proepoxy/metallic-steps/MetallicStep4';
import MetallicStep5 from '@/components/proepoxy/metallic-steps/MetallicStep5';
import MetallicStep6 from '@/components/proepoxy/metallic-steps/MetallicStep6';
import MetallicStep7 from '@/components/proepoxy/metallic-steps/MetallicStep7';
import RecipePicker from '@/components/proepoxy/RecipePicker';

const MetallicEpoxyFlow = ({ currentStep, goToStep, onExit }) => {
  const navigate = useNavigate();
  const [priority, setPriority] = React.useState('no_rush');
  const metallic = useMetallicOrder(currentStep);
  const [voucher, setVoucher] = useState({ id: null, value: 0 });
  const voucherAreaM2 = (metallic.primerAreas || []).reduce((a, x) => a + (parseFloat(x.m2) || 0), 0);
  const { steps } = metallic;

  return (
    <>
            {/* Recipe Picker — visible on every step so installers can start
                from a signature look or swap mid-quote. Hidden until the
                catalogue has at least one active recipe. */}
            <RecipePicker state={metallic} />

            {/* Progress Indicator */}
            <div className="bg-white rounded-2xl shadow-sm p-4 mb-6">
              <div className="flex items-center justify-between mb-3">
                <h2 className="font-bold text-[#27292E]">Metallic Epoxy</h2>
                <span className="text-sm text-gray-500">Step {currentStep} of 7</span>
              </div>
              <div className="flex">
                {steps.map(step => (
                  <button 
                    key={step.num} 
                    className="flex-1 flex flex-col items-center min-w-0"
                    onClick={() => goToStep(step.num)}
                  >
                    <div 
                      className={`w-full h-2 rounded-full transition-all mx-0.5 ${
                        step.num <= currentStep ? 'bg-[#7A0B7A]' : 'bg-gray-200'
                      }`}
                    />
                    <p className={`text-[9px] sm:text-xs mt-1 text-center cursor-pointer hover:text-[#7A0B7A] transition-colors truncate w-full px-0.5 ${
                      step.num === currentStep ? 'text-[#7A0B7A] font-medium' : 'text-gray-400'
                    }`}>
                      {step.title}
                    </p>
                  </button>
                ))}
              </div>
            </div>

            {/* Step 1: Define Areas */}
            {currentStep === 1 && (
              <MetallicStep1
                state={metallic}
                priority={priority}
                setPriority={setPriority}
                currentStep={currentStep}
                goToStep={goToStep}
                navigate={navigate}
                onExit={onExit}
              />
            )}

            {/* Step 2: Floor Preparation */}
            {currentStep === 2 && (
              <MetallicStep2
                state={metallic}
                priority={priority}
                setPriority={setPriority}
                currentStep={currentStep}
                goToStep={goToStep}
                navigate={navigate}
                onExit={onExit}
              />
            )}

            {/* Step 3: Primer */}
            {currentStep === 3 && (
              <MetallicStep3
                state={metallic}
                priority={priority}
                setPriority={setPriority}
                currentStep={currentStep}
                goToStep={goToStep}
                navigate={navigate}
                onExit={onExit}
              />
            )}

            {/* Step 4: Design Coat */}
            {currentStep === 4 && (
              <MetallicStep4
                state={metallic}
                priority={priority}
                setPriority={setPriority}
                currentStep={currentStep}
                goToStep={goToStep}
                navigate={navigate}
                onExit={onExit}
              />
            )}

            {/* Step 5: Pigments, Glitters and Sprays */}
            {currentStep === 5 && (
              <MetallicStep5
                state={metallic}
                priority={priority}
                setPriority={setPriority}
                currentStep={currentStep}
                goToStep={goToStep}
                navigate={navigate}
                onExit={onExit}
              />
            )}

            {/* Step 6: Protective Top Coats */}
            {currentStep === 6 && (
              <MetallicStep6
                state={metallic}
                priority={priority}
                setPriority={setPriority}
                currentStep={currentStep}
                goToStep={goToStep}
                navigate={navigate}
                onExit={onExit}
              />
            )}

            {/* Step 7: Order Summary */}
            {currentStep === 7 && (
              <MetallicStep7
                voucher={voucher}
                state={metallic}
                priority={priority}
                setPriority={setPriority}
                currentStep={currentStep}
                goToStep={goToStep}
                navigate={navigate}
                onExit={onExit}
              />
            )}
            <div className="mt-6"><VoucherRail brand="proepoxy" system="metallic" areaM2={voucherAreaM2} items={[]} selectedId={voucher.id} onSelect={(id, value) => setVoucher({ id, value })} accent="#F5B301" /></div>
    </>
  );
};

export default MetallicEpoxyFlow;
